export const DEMOGRAPHICS_LIST_GLOBAL_FETCH_DATA_REQUEST = 'DEMOGRAPHICS_LIST_GLOBAL_FETCH_DATA_REQUEST';
export const DEMOGRAPHICS_LIST_GLOBAL_FETCH_DATA_START = 'DEMOGRAPHICS_LIST_GLOBAL_FETCH_DATA_START';
export const DEMOGRAPHICS_LIST_GLOBAL_FETCH_DATA_ERROR = 'DEMOGRAPHICS_LIST_GLOBAL_FETCH_DATA_ERROR';
export const DEMOGRAPHICS_LIST_GLOBAL_FETCH_DATA_SUCCESS = 'DEMOGRAPHICS_LIST_GLOBAL_FETCH_DATA_SUCCESS';
